import React, { useRef } from "react"
import Slider from "react-slick"
import './styles.scss'


const getVisibleSlides = (sliderRef, currentSlide) => {
  if (!sliderRef.current) return 0;

  const slick = sliderRef.current.innerSlider;
  const listWidth = slick.list.offsetWidth;
  const slideNodes = slick.list.querySelectorAll('.slick-slide');

  let visibleCount = 0;
  let accumulatedWidth = 0;

  for (let i = currentSlide; i < slideNodes.length; i++) {
    const slide = slideNodes[i];
    if (!slide) break;

    const slideWidth = slide.offsetWidth;
    if (accumulatedWidth + slideWidth <= listWidth) {
      accumulatedWidth += slideWidth;
      visibleCount++;
    } else {
      break;
    }
  }

  return visibleCount;
}

const ChatImages = ({images = [], style = {marginTop: '0px'} }) => {
  const sliderRef = useRef(null)
  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    outerHeight: 'auto',
    swipe: false,
    draggable: false,
    arrows: true,
    nextArrow: <ScrollButtons sliderRef={sliderRef}/>,
    prevArrow: <ScrollButtons mode='left'/>
  }
  let imageBlocks = images.map((img, idx) => {
    let src = null
    let title = null
    if (typeof img === 'string') {
      src = img
    } else if (typeof img === 'object') {
      src = img?.url
      title = img?.value
    }
    if (src) {
      return <div key={idx} className='image-block'><img src={src} title={title}/></div>
    } else {
      return null
    }
  })
  return (
    <div className='chat-image-slider-container' style={style}>
      <Slider ref={sliderRef} {...settings}>
        {imageBlocks}
      </Slider>
    </div>
  )
}

const ScrollButtons = (props) => {
  const { mode = 'right', onClick, currentSlide, slideCount, sliderRef } = props || {}
  let buttonIcon = <i className='fas fa-chevron-right'></i>
  let buttonType = mode === 'left' ? 'left' : 'right'
  let visibilityModifier = ''
  if (mode === 'left') {
    buttonIcon = <i className='fas fa-chevron-left'></i>
    if (currentSlide === 0) {
      visibilityModifier = 'no-show'
    }
  } else {
    const visibleSlides = getVisibleSlides(sliderRef, currentSlide)
    if (currentSlide+visibleSlides >= slideCount) {
      visibilityModifier = 'no-show'
    }
  }
  return (
    <div className={`scroll-button-container ${buttonType} ${visibilityModifier}`}>
      <div className={`scroll-button`} onClick={onClick}>
        {buttonIcon}
      </div>
    </div>
  )
}

export default ChatImages